<template>
  <ElForm
    ref="editPriceOfferForm"
    :model="formModel"
    :rules="formRules"
    class="modal-form"
  >
    <ElFormItem
      size="mini"
      :label="$t('ADVERTISEMENT.BID.MAX_CPI')"
      prop="priceOffer"
    >
      <ElInput
        v-model.number="formModel.priceOffer"
        type="number"
        name="priceOffer"
        required
        size="mini"
      />
    </ElFormItem>
    <ElFormItem class="modal-form__actions">
      <ElButton size="mini" type="text" @click="validateAndEmitSave">
        {{ $t('SAVE') }}
      </ElButton>
      <ElButton size="mini" type="text" @click="close">
        {{ $t('CANCEL') }}
      </ElButton>
    </ElFormItem>
  </ElForm>
</template>

<script>
import required from '@/utils/validation-rules/required';

import form from '@/mixins/form';

export default {
  name: 'BidPriceOfferColumnForm',
  mixins: [form],
  props: {
    initialPriceOffer: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formModel: {
        priceOffer: this.initialPriceOffer,
      },
    };
  },
  computed: {
    formRules() {
      return {
        priceOffer: required(this.$t('VALIDATION_REQUIRED_ERR')),
      };
    },
  },
  watch: {
    initialPriceOffer(newVal, val) {
      if (newVal !== val) {
        this.formModel.priceOffer = newVal;
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    validateAndEmitSave() {
      if (this.isValid('editPriceOfferForm')) {
        this.$emit('save', this.formModel.priceOffer);
      }
    },
  },
};
</script>
